// import { useStartExam, type StartExamInEventMutationResponse } from '@exam-room/graphql';
// import { omit } from '@exam-room/utils';
// import { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';

import { Card } from '../../../components';
// import { useExam, useExamForm, type ExamFormInput } from '../../../providers';
import { PATHS } from '../../../routes';

// default to 10 minutes.
// const breakDurationInMinutes = 10;

// function calculateDateEndAt(minute: number) {
//   return new Date(new Date().getTime() + minute * 60000);
// }

function Break() {
  // const navigate = useNavigate();
  // const { examCardId } = useParams();

  // const [enableStartExam, setEnableStartExam] = useState(false);
  // const [isLoadingExam, setLoadingExam] = useState(false);
  // const [timerEndTime, setTimerEndTime] = useState<Date | null>(null);

  // const { reset } = useExamForm();
  // const { nextExamIdRef } = useExam();

  // const [startExam, { client }] = useStartExam();
  // const [getNextModule] = useResolveNextModule({
  //   variables: { examCardId: examCardId as string },
  // });

  // useEffect(() => {
  //   async function checkRemainingBreakTime() {
  //     try {
  //       await getNextModule({
  //         onCompleted: async (data) => {
  //           const { examId, type, endedAt, duration } = data.qmsResolveNextExamModuleInfo;

  //           if (type !== NextExamModuleType.Break) {
  //             navigate(generatePath(PATHS.Exam.Root, { examCardId }));
  //           }

  //           nextExamIdRef.current = examId;

  //           // Check exam type by `endedAt` and `duration` because we hasn't exam session in break page
  //           // 1. `endedAt` for SAT, user can clicks resume button when break time up.
  //           // 2. `duration` for SAT_DYNAMIC, user can clicks resume button anytime.
  //           // 3. If have a break but hasn't not `endedAt` and `duration`, auto set break time 10 min and user can clicks resume button anytime.
  //           if (endedAt) {
  //             setTimerEndTime(new Date(parseInt(endedAt)));
  //           } else if (typeof duration === 'number') {
  //             setEnableStartExam(true);
  //             setTimerEndTime(calculateDateEndAt(duration));
  //           } else {
  //             setEnableStartExam(true);
  //             setTimerEndTime(calculateDateEndAt(breakDurationInMinutes));
  //           }
  //         },
  //       });
  //     } catch (error) {
  //       console.error('Unexpected Error, Break Time not valid.');
  //       console.error(error);
  //       navigate(PATHS.Error);
  //     }
  //   }

  //   checkRemainingBreakTime();
  // }, []);

  // async function resetFormValues(data: StartExamInEventMutationResponse) {
  //   const examPaperItemData =
  //     data?.qmsExamRoomStartExamInEvent?.examRoomAnswer?.examRoomExamPaperItems;

  //   const initialValues: ExamFormInput = {};
  //   examPaperItemData?.forEach((data) => {
  //     const { refId, answer, ...restData } = omit(data, ['__typename']);
  //     if (refId) {
  //       initialValues[refId] = {
  //         ...restData,
  //         refId,
  //         answer: answer.value,
  //       };
  //     }
  //   });

  //   reset(initialValues);
  // }

  // async function handleResume() {
  //   try {
  //     setLoadingExam(true);

  //     await startExam({
  //       variables: {
  //         input: {
  //           examCardId: examCardId as string,
  //           examId: nextExamIdRef.current as string,
  //           isSetTimer: true,
  //         },
  //       },
  //       onCompleted: async (data) => {
  //         nextExamIdRef.current = null;
  //         await client.refetchQueries({ include: ['qmsExamRoomGetExam'] });

  //         await resetFormValues(data);
  //         navigate(generatePath(PATHS.Exam.Root, { examCardId }));
  //       },
  //       onError: async () => {
  //         nextExamIdRef.current = null;

  //         await getNextModule({
  //           onCompleted: async (data) => {
  //             const { type, examId } = data?.qmsResolveNextExamModuleInfo ?? {};

  //             // if next module type === 'FINISH', should redirect to `/completed` page
  //             if (type === NextExamModuleType.Finish) {
  //               navigate(generatePath(PATHS.Exam.Completed, { examCardId }));
  //               // if next module type === 'EXAM', should start exam automatically
  //             } else {
  //               await startExam({
  //                 variables: {
  //                   input: {
  //                     examCardId: examCardId as string,
  //                     isSetTimer: true,
  //                     examId: examId as string,
  //                   },
  //                 },
  //                 onCompleted: async (data) => {
  //                   await client.refetchQueries({ include: ['qmsExamRoomGetExam'] });

  //                   await resetFormValues(data);
  //                   navigate(generatePath(PATHS.Exam.Root, { examCardId }));
  //                 },
  //                 onError: () => {
  //                   navigate(PATHS.Error);
  //                 },
  //               });
  //             }
  //           },
  //           onError: () => {
  //             navigate(PATHS.Error);
  //           },
  //         });
  //       },
  //     });
  //   } catch (e) {
  //     console.error('Unable to start next Exam with error: ', e);
  //   }
  // }

  return (
    <div className='flex h-full w-full flex-col'>
      <div className='text-text-primary flex grow flex-col items-center gap-8 overflow-y-scroll pt-24 pb-10'>
        <div className='grid place-items-center'>
          <Card className='py6 grid gap-5 rounded-lg px-10 text-center text-black'>
            <h3 className='font-semibold'>Remaining Break Time:</h3>
            {/* {nextExamIdRef.current && timerEndTime ? (
              <>
                <Timer
                  endedAt={timerEndTime}
                  onTimerEnd={() => setEnableStartExam(true)}
                  size='lg'
                />
                <Button
                  variant='outlined'
                  className='mx-auto'
                  onClick={handleResume}
                  disabled={!enableStartExam || isLoadingExam}
                >
                  {isLoadingExam ? (
                    <div className='grid h-[28px] w-[139px] place-items-center'>
                      <LoadingSpinner className='h-6 w-6' />
                    </div>
                  ) : (
                    'Resume Testing'
                  )}
                </Button>
              </>
            ) : (
              <TimerSkeleton className='mx-auto h-16 w-48' />
            )} */}
          </Card>
        </div>
        <div className='mx-auto flex max-w-5xl grow flex-col gap-6 p-9'>
          <h1 className='font-semibold'>Practice Test Break</h1>
          <p>
            {`You can resume this practice test as you are ready to move on. On test day, you will need
            to wait until the break time is up.`}
          </p>
          <h2 className='mt-4 text-4xl font-semibold'>Take a Break</h2>
          <ul className='[&>*]:ml-6 [&>*]:list-disc'>
            <li>You may leave the room, but do not disturb students who are still testing.</li>
            <li>Do not exit this page or turn off your laptop.</li>
            <li>The test will not resume until you return.</li>
          </ul>

          <h4 className='font-semibold'>Follow these rules during the break:</h4>
          <ol className='[&>*]:ml-6 [&>*]:list-decimal'>
            <li>Do not access your phone, textbooks, notes, or the internet.</li>
            <li>Do not eat or drink in the exam room.</li>
            <li>Do not speak in and out the exam room.</li>
            <li>Keep quiet and do not discuss the exam with anyone.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

const BreakRoute = {
  path: PATHS.Exam.Break,
  element: <Break />,
};

export default BreakRoute;
